import UseStoreHandler from "@/composables/handlers/UseStoreHandler";
import BaseModel from "./BaseModel";

/**
 * Tag
 */
export default class Tag extends BaseModel{
  
  constructor({
    id,
    name,
    en,
    pt,
    es
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.en = en || null;
    this.pt = pt || null;
    this.es = es || null;
  }

  getTranslatedName() {
    const langIso = UseStoreHandler.getContextStore().getLang;
    return ![null, undefined, ''].includes(this[langIso]) ? this[langIso] : this.name;
  }
}